import classNames from 'classnames';

import ArrowsUpDownLine from '@/assets/icons/arrows_up_down_line.svg?component';
import BarsDescendingFill from '@/assets/icons/bars_descending_fill.svg?component';
import BasketHarvestFill from '@/assets/icons/basket_harvest_fill.svg?component';
import BoatFill from '@/assets/icons/boat_fill.svg?component';
import FishGroupLine from '@/assets/icons/fish_group_line.svg?component';
import PathMergeLine from '@/assets/icons/path_merge_line.svg?component';
import PathSplitLine from '@/assets/icons/path_split_line.svg?component';
import { type IconComponent, SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';

import styles from './ActionIcon.module.scss';

export type FishGroupActionKind =
    | 'fishGroup'
    | 'move'
    | 'delousing'
    | 'split'
    | 'grading'
    | 'merge'
    | 'harvest';

const ICONS: Record<FishGroupActionKind, IconComponent> = {
    fishGroup: FishGroupLine,
    move: ArrowsUpDownLine,
    delousing: BoatFill,
    split: PathSplitLine,
    grading: BarsDescendingFill,
    merge: PathMergeLine,
    harvest: BasketHarvestFill,
};

interface ActionIconProps {
    kind: FishGroupActionKind;
    /** `sm` 28px for a button, `md` 40px for the group header, `lg` 48px for a dialog's. */
    size?: 'sm' | 'md' | 'lg';
}

/**
 * A fish group action's glyph on a disc tinted with the action's board colour, the same colours
 * as the board's event badges. Decorative: the label beside it names the action.
 */
export default function ActionIcon(props: ActionIconProps) {
    const { kind, size = 'sm' } = props;
    return (
        <span
            className={classNames(styles.disc, styles[`disc--${size}`])}
            data-kind={kind}
            aria-hidden="true">
            <SvgIcon icon={ICONS[kind]} size="inherit" svgProps={{ focusable: 'false' }} />
        </span>
    );
}
